@if (haveData) {
  <div id="all-content" fxLayoutAlign="start center" fxLayout="column">
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
      <div>
        <h1 class="heading">Join {{ accountName }}'s Lineup account.</h1>
        <br />
        <dl>
          <dt>Your Account URL</dt>
          <dd>{{ accountUrl | cleanUrl }}</dd>
          <dt>Your Login Email</dt>
          <dd>{{ userEmail }}</dd>
        </dl>
        <br />
        <div class="instruction">Please set the password for your account.</div>
        <div class="field" fxLayout="column">
          <mat-form-field appearance="outline">
            <mat-label>Password</mat-label>
            <input
              matInput
              type="password"
              formControlName="password"
              required
            />
            @if (
              passwordForm.get('password').hasError('passwordStrengthError')
            ) {
              <mat-error id="password-strength-err">
                {{ passwordStrengthError }}
              </mat-error>
            }
            @if (
              passwordForm.get('password').hasError('passwordMismatchError')
            ) {
              <mat-error id="password-mismatch-err">
                {{ passwordMismatchError }}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="field" fxLayout="column">
          <mat-form-field appearance="outline">
            <mat-label>Confirm Password</mat-label>
            <input
              matInput
              type="password"
              formControlName="confirmPassword"
              required
            />
            @if (
              passwordForm
                .get('confirmPassword')
                .hasError('passwordStrengthError')
            ) {
              <mat-error id="confirm-password-strength-err">
                {{ passwordStrengthError }}
              </mat-error>
            }
            @if (
              passwordForm
                .get('confirmPassword')
                .hasError('passwordMismatchError')
            ) {
              <mat-error id="confirm-password-mismatch-err">
                {{ passwordMismatchError }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      @if (recaptchaSiteKey) {
        <re-captcha
          formControlName="recaptcha"
          [siteKey]="recaptchaSiteKey"
        ></re-captcha>
      }
      <button
        class="mat-flat-button submit-button"
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="!isSubmitEnabled()"
      >
        Set Password
      </button>
    </form>
  </div>
}
